import 'whatwg-fetch';
import config from '../../config/config';

const {
    API_BANNER_URL,
} = config;

export const bannersApi = {
    fetchList: async (params = {}) => {
        const queryParams = new URLSearchParams({
            per_page: params.per_page || 10,
        }).toString();

        const fetchOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        };

        const response = await fetch(
            `${API_BANNER_URL}?${queryParams}`,
            fetchOptions
        );

        if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        const data = await response.json();

        return {
            data: data || [],
            total: data.length,
            totalPages: 1,
            page: 1,
        }
    },
}
